//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations } from "vuex";
export default {
	name: "SearchBox",
	props: ["searchPlaceholder", "searchButtonText", "showAlpha"],
	computed: {
		...mapGetters(['settings', 'results', 'searchQuery']),
		query: {
			get() {
				return this.searchQuery.searchTerm;
			},
			set(value) {
				this.setQuery(value);
			}
		},

		alphaFilter: {
			get() {
				return this.searchQuery.alphaFilter;
			},
			set(value) {
				if (value === this.searchQuery.alphaFilter) {
					value = "";
				}
				this.setAlphaFilter(value);
			}
		},

		currentResultStart() {
			if (this.results.currentPage == 0) {
				return 1;
			} else {
				return this.results.currentPage * this.results.pageSize + 1;
			}
		},

		currentResultsEnd() {
			if (this.results.currentPage == 0) {
				if (this.total <= this.results.pageSize) {
					return this.totalPages;
				} else {
					return this.results.pageSize;
				}
			} else {
				var max = (this.results.currentPage + 1) * this.results.pageSize + 1;
				if (max > this.total) {
					return this.total;
				} else {
					return max;
				}
			}
		},
	},
	methods: {
		...mapMutations(['setQuery', 'setAlphaFilter']),
		submitAlphaFilter(letter) {
			this.alphaFilter = letter;
			this.$emit("submitalphafilter");
		},
		submitSearch() {
			this.$emit("submitsearch");
		},
	},
};
